class Flourish {
    constructor(flourish) {
        this.removeFallback(flourish);
        this.showEmbed(flourish);
        this.fireChartbeat();

        // add resize listener
        window.addEventListener('message', (event) => {
            try {
                const message = (typeof event.data === 'object' ? null : JSON.parse(event.data));
                if (message && message.source === 'Flourish' && message.context === 'iframe.resize') {
                    document.getElementById(`flourish-fallback-${this.namespaceId}`).style.height = message.height;
                }
            }
            catch (e) {
                console.error(e);
            }
        });
    }

    fireChartbeat () {
        this.chartbeatAttempts = (this.chartbeatAttempts || 0) + 1;
        var maxAttempts = 10;
        var chartbeatExists = !!(window._sf_async_config);
        var charbeatInitialised = chartbeatExists && window._sf_async_config.hasOwnProperty('sections');
        var that = this;

        if (charbeatInitialised) {
            window._sf_async_config.sections = window._sf_async_config.sections.replace(', Visual Journalism', '') + ', Visual Journalism';
        } else if (this.chartbeatAttempts < maxAttempts) {
            // there may be occasions where chartbeat isn't on the page, so we should stop after 10 attempts
            window.setTimeout(function(){ that.fireChartbeat() }, 500);
        }
    }

    hasQueryString(url) {
        return !!(/[?&][a-zA-Z0-9]+=*/.test(url));
    }

    removeFallback(flourish) {
        const fallback = document.getElementById(`flourish-fallback-${flourish.namespaceId}`);
        document.getElementById(`flourish-container-${flourish.namespaceId}`).removeChild(fallback);
    }

    showEmbed(flourish) {
        document.getElementById(`flourish-embed-container-${flourish.namespaceId}`).removeAttribute('class');
    }
}

new Flourish({
    namespaceId: `${DEV_SCAFFOLD('name')}-${DEV_SCAFFOLD('includeName')}`,
    title: __('title'),
    flourish_id: __('flourish_id'),
});
